import React, { useEffect } from "react"
import { useCartStore } from "../../hooks/useCartStore"

type OrderModalProps = {
	pupup: {
		descr: {value: string}
		img: string
		title: {value: string}
		url: string
	}
}

export const OrderModal: React.FC<OrderModalProps> = ({ pupup }) => {

	const modalOrder = useCartStore(state => state.modalOrder)

	const { title, descr, img } = pupup
	
	const handleClose = () => {
		useCartStore.setState({ modalOrder: false })
		window.dataLayer.push({
			'event': 'GAEvent',
			'event_category': 'Content',
			'event_action': 'Button',
			'event_label': 'Processing your order',
			'interaction':'true',
			'component_name': 'Modo_Carrera_TaDa_ShoppingCart',
			'element_text': 'Cerrar',
		});
	}

	useEffect(() => {
		if (modalOrder === true) {
			window.dataLayer.push({
				'event': 'GAEvent',
				'event_category': 'Content',
				'event_action': 'Button',
				'event_label': 'Processing your order',
				'interaction':'true',
				'component_name': 'Modo_Carrera_TaDa_ShoppingCart',
				'element_text': 'Estamos procesando tu pedido',
			});
		}
	}, [modalOrder])

	return (
		<section className={`ar__tadaShop__order ${modalOrder && 'is-open'}`}>
			<div className="ar__tadaShop__order__modal">
				<div className="ar__tadaShop__order__modal__close" style={{ display: 'none'}} onClick={handleClose}></div>
				<div className="ar__tadaShop__order__modal__content">
					<div className="ar__tadaShop__order__modal__content__image">
						<img src={img} alt="Estamos pocesando tu pedido" />
					</div>
					<h2 className="ar__tadaShop__order__modal__content__title" dangerouslySetInnerHTML={{ __html: title.value }}></h2>
					<p className="ar__tadaShop__order__modal__content__desc" dangerouslySetInnerHTML={{ __html: descr.value }}></p>
				</div>
			</div>
		</section>
	)
}